import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Content, AlertController, Platform, ToastController } from 'ionic-angular';
import { ActionSheetController } from 'ionic-angular';
// import { PhotoLibrary } from '@ionic-native/photo-library';
import { PhotoLibrary } from './../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { CallNumber } from '@ionic-native/call-number';
import { AbstractPage } from '../../_com/abstract-page';
import { ChatAction } from '../../../actions/chat.action';
import { ReserveAction } from '../../../actions/reserve.action';
import { PhotoAction, _PhotoAction } from '../../../actions/photo.action';
import { ReserveEditPage } from '../edit/reserve-edit';
import { Subscription } from 'rxjs/Subscription';
import { ChildDetailPage } from '../../child/detail/child-detail';
import { InterviewSheetEditFamilyPage } from "../interview/edit-family/reserve-interview-edit-family";
import { InterviewSheetDetailStaffPage } from "../../reserve/interview/detail-staff/reserve-interview-detail-staff";
import { InterviewSheetEditStaffPage } from "../interview/edit-staff/reserve-interview-edit-staff";

import { MessageSheetPage } from '../../reserve/messagesheet/reserve-messagesheet';
import { ReservePickupDetailPage } from '../../reserve/pickup/detail/reserve-pickup-detail';
import { ReservePickupEditPage } from '../../reserve/pickup/edit/reserve-pickup-edit'
import { PhotoRequestSelectionPage } from '../../photo-request/selection/photo-request-selection';
import { PhotoRequestCompletePage } from '../../photo-request/complete/photo-request-complete';
import { ReserveEditPhotoRequestMessagePage } from '../../photo-request/message-edit/reserve-edit-photo-request-message';
import { AuthStore } from '../../../stores/auth-store';
import { BadgeStore } from '../../../stores/badge-store';
import { LoadingService } from '../../../providers/loading-service';
import Utils from '../../../_com/utils';
import { BasicState } from '../../../states/basic-state';
import _ from 'underscore';
import { HttpFamilyProvider } from '../../../providers/http-family';
import { ModalController } from "ionic-angular";
import { SignatureAgreementPage } from '../../signature/signature-agreement/signature-agreement';
import { NotebookEditPage } from '../noteboook/notebook-edit/notebook-edit';
import { NotebookListPage } from '../noteboook/notebook-list/notebook-list';

/**
 * Generated class for the ReserveDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: "page-reserve-detail",
  templateUrl: "reserve-detail.html",
})
export class ReserveDetailPage extends AbstractPage {
  data: any;
  chatText: String;
  chatList: any;
  pickupData: any;
  agreementDate: any;
  isInterviewSheetExists: Boolean;
  isPickupDataExists: Boolean;
  agree: Boolean;
  _utils = Utils;
  path = "";
  captureData$: Subscription;
  captureDatas$: Subscription;
  onChangeChildDetail: Subscription;

  photoAction: _PhotoAction;

  interviewArr = [];
  interviewData = {};
  interviewId = {};
  childId = "";

  @ViewChild(Content) content: Content;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public chatAction: ChatAction,
    public reserveAction: ReserveAction,
    public tmpPhotoAction: PhotoAction,
    private pv: PhotoViewer,
    private pl: PhotoLibrary,
    private loadingService: LoadingService,
    private actionSheetController: ActionSheetController,
    private alertController: AlertController,
    private toastController: ToastController,
    private plt: Platform,
    private callNumber: CallNumber,
    private basicState: BasicState,
    private authStore: AuthStore,
    private badgeStore: BadgeStore,
    private httpFamilyProvider: HttpFamilyProvider,
    private modalController: ModalController
  ) {
    super();

    this.photoAction = tmpPhotoAction.getInstance();

    this.drawScreen(this.navParams.data.Reserve);
    this.takePictureDataSubscribe();

    this.pl; //for TSLint
    this.pv; //for TSLint
    this.plt; //for TSLint
    this.callNumber; //for TSLint

    // 送迎情報が存在している場合、true,存在しない場合、false
    this.isPickupDataExists = this.navParams.data.Reserve.pickup ? true : false;

    /**
     * 子供情報が更新されたイベント
     */
    this.onChangeChildDetail = this.basicState.onChangeChildDetail.subscribe(
      (data) => {
        this.dataReload(this.data["id"]);
      }
    );

    // this.showMessengerKeyboard();
  }

  /**
   * 初期処理
   */
  ionViewDidLoad() {
    this.chatRefresh();
  }

  /**
   * 画面遷移時イベント
   */
  ionViewDidEnter() {
    this.dataReload(this.data["id"]);
    this.getInterviewSheet();
    this.getAgreementDate();
  }

  /**
   * チャットリフレッシュ
   */
  chatRefresh(isScroll: boolean = false) {
    this.chatAction.getList(this.data["id"]).subscribe((res) => {
      this.chatList = res["data"];
      if (isScroll) {
        super.scrollTo(this.content, "reserve_detail_chat");
      }
    });
  }

  /**
   * チャット送信ボタンの活性チェック
   */
  isSendableChat() {
    return this.chatText;
  }

  /**
   * 予約編集
   */
  openReserveEdit() {
    //編集用データ準備（家族データ）
    var family = this.data.family.data.Family;
    var children = [];
    for (var index in this.data.children) {
      var d = this.data.children[index]["data"];
      children.push(d);
    }
    family["children"] = children;

    //編集用データ
    var data = {
      id: this.data["id"],
      date: new Date(this.data.datetime.input.date),
      time: [
        new Date(this.data.datetime.input.time[0]),
        new Date(this.data.datetime.input.time[1]),
      ],
      family: family,
      type: this.data["type"],
      bathRequest: this.data["bathRequest"],
      status: this.navParams.data["Reserve"]["status"],
      pickup: this.data["pickup"], // 送迎情報を編集ページに送る
    };

    //編集画面遷移
    this.navCtrl.push(ReserveEditPage, data);
  }

  /**
   * データを再読込する
   */
  dataReload(reserveId) {
    this.reserveAction.getList({ id: reserveId }).subscribe((res) => {
      this.drawScreen(res.data[0]["Reserve"]);
    });
  }

  /**
   * 画面に描画する
   */
  drawScreen(reserveData) {
    this.data = reserveData;
    // 送迎情報が存在している場合、true,存在しない場合、false
    this.isPickupDataExists = reserveData.pickup ? true : false;
  }

  /**
   * 写真向けメッセージ編集画面へ
   */
  editPhotoRequestMessage() {
    this.navCtrl.push(ReserveEditPhotoRequestMessagePage, this.data);
  }

  /**
   * 写真撮影/アルバム選択
   */
  takePicture() {
    let actionSheet = this.actionSheetController.create({
      title: "選択してください",
      buttons: [
        {
          text: "写真を撮影する",
          handler: () => {
            this.photoAction.takeCamera({
              needModal: true,
              screen: "reserve_detail",
            });
          },
        },
        {
          text: "アルバムから選択する",
          handler: () => {
            this.uploadReady = [];
            this.photoAction.photoSelectMultiple({
              needModal: true,
              screen: "reserve_detail",
            });
          },
        },
        {
          text: "キャンセル",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }

  /**
   * 写真データ取得時イベント
   */
  uploadReady = [];
  takePictureDataSubscribe() {
    var self = this;

    /* カメラ撮影(1数) */
    this.captureDatas$ = this.photoAction.captureDatas$.subscribe(
      (imageDatas) => {
        if (self.photoAction.getScreen() != "reserve_detail") return;
        this.uploadReady = imageDatas;
        this.send();
      }
    );

    /* 写真選択(複数枚) */
    this.captureData$ = this.photoAction.captureData$.subscribe((imageData) => {
      if (self.photoAction.getScreen() != "reserve_detail") return;
      this.uploadReady = [imageData];
      this.send();
    });
  }

  /**
   * チャット削除
   */
  removeChat(chatId) {
    this.confirm(this.alertController, "削除します。よろしいですか？", () => {
      this.chatAction.removeChat(chatId).subscribe((data) => {
        this.toast(this.toastController, "削除しました");
        this.chatRefresh();
      });
    });
  }

  /**
   * 写真データ送信
   */
  send() {
    this.loadingService.present("");

    var updateData = {
      room_id: this.data["id"],
      room_type: "reserve",
      message: this.chatText,
      imageData: this.uploadReady[0],
    };

    this.chatAction.savePicture(updateData).subscribe((data) => {
      if (data.data) {
        this.uploadReady.shift();
        if (this.uploadReady.length > 0) {
          this.send();
        } else {
          this.toast(this.toastController, "写真のアップロードが完了しました");
          this.chatRefresh(true);
        }
      } else {
        this.loadingService.dissmiss();
        this.alert(
          this.alertController,
          "一部写真のアップロードにしました。ご確認お願いします。"
        );
      }
    });
  }

  /**
   * チャットテキスト表示内容を調整
   */
  getChatViewText(chat) {
    var res = "";
    switch (chat.Chat.type) {
      case "photoRequest":
        res = "[写真を送信しました]\n\n" + chat.Chat.message;
        break;
      default:
        res = chat.Chat.message;
        break;
    }
    return res;
  }

  /**
   * 予約リクエストを承認する
   */
  reserveRequestAccept() {
    this.confirm(
      this.alertController,
      "この予約を承認します。よろしいですか？",
      () => {
        this.reserveAction
          .reserveRequestAccept(this.data["id"])
          .subscribe((data) => {
            this.toast(this.toastController, "予約を承認しました");
            this.navCtrl.pop();
            this.refreshBadge();
          });
      }
    );
  }

  /**
   * 予約リクエストを却下する
   */
  reserveRequestRejection() {
    this.confirm(
      this.alertController,
      "この予約を却下します。よろしいですか？",
      () => {
        this.reserveAction
          .reserveRequestRejection(this.data["id"])
          .subscribe((data) => {
            this.toast(this.toastController, "予約を却下しました");
            this.navCtrl.pop();
            this.refreshBadge();
          });
      }
    );
  }

  /**
   * 予約リクエストを保留状態にする
   */
  reserveRequestHold() {
    this.confirm(
      this.alertController,
      "この予約を保留にします。よろしいですか？",
      () => {
        this.reserveAction
          .reserveRequestHold(this.data["id"])
          .subscribe((data) => {
            this.toast(this.toastController, "予約を保留にしました");
            this.navCtrl.pop();
            this.refreshBadge();
          });
      }
    );
  }

  /**
   * バッジを最新化する
   */
  refreshBadge() {
    this.reserveAction.getListReserveRequest().subscribe((data) => {
      this.badgeStore.setBadgeReserveRequest(data.data.length);
    });
  }

  /**
   * 予約キャンセル
   */
  reserveCancel() {
    this.confirm(
      this.alertController,
      "この予約をキャンセルします。よろしいですか？",
      () => {
        this.reserveAction.reserveCancel(this.data["id"]).subscribe((data) => {
          this.toast(this.toastController, "予約をキャンセルしました");
          this.navCtrl.pop();
        });
      }
    );
  }

  /**
   * チャット送信処理
   */
  chatSend(text) {
    var updateData = {
      room_id: this.data["id"],
      room_type: "reserve",
      message: text,
    };

    this.chatAction.save(updateData).subscribe((data) => {
      this.chatText = "";
      this.chatRefresh(true);
    });
  }

  /**
   * チャット吹き出し用のme or himを取得する
   */
  getSpeaker(chat) {
    return chat.Chat.editor == this.authStore.getLoginData("id") ? "me" : "him";
  }

  /**
   * 問診票情報が入力されているか確認する
   * isInterviewSheetExists: true(問診票情報が登録されている),false(問診票情報が登録されていない)
   */
  getInterviewSheet() {
    for (var index in this.data.children) {
      this.reserveAction
        .getInterviewData({
          reserveId: this.data["id"],
          childId: this.data.children[index]["id"],
        })
        .subscribe((res) => {
          // ここでデータを取得する
          if (res.data.length) {
            // データ画面に反映
            this.interviewData = res.data[0]["InterviewSheet"]["interviewInfo"];
            this.interviewId = res.data[0]["InterviewSheet"]["id"];
            this.childId = res.data[0]["InterviewSheet"]["childId"];
          } else {
            // 入力されていない旨を表示する
            this.childId = "";
          }
          this.interviewArr.push(this.childId);
        });
    }
  }

  /**
   * 問診票が未登録かどうか判断する
   */
  showMessage(child) {
    let isShow = false;
    if (this.interviewArr.includes(child["Child"]["id"])) {
      isShow = true;
    }
    return isShow;
  }

  /**
   * 問診票情報が入力されているか確認する
   * agree: 同意している場合、true
   */
  getAgreementDate() {
    this.httpFamilyProvider
      .getAgreementDate({ family: this.data["family"]["id"] })
      .subscribe((res) => {
        console.log("res.data", res.data);
        console.log(
          "Object.keys(res.data).length",
          Object.keys(res.data).length
        );
        if (Object.keys(res.data).length) {
          this.agreementDate = res.data["Agreement"]["agree_date"];
          this.agree = res.data["Agreement"]["agreement"];
        } else {
          this.agree = false;
        }
      });
  }

  /**
   * 子供画面へ移動
   */
  goChild(child, family) {
    this.navCtrl.push(ChildDetailPage, { child: child, family: family });
  }

  // *** *** *** *** ***  ***
  // *** 問診票が未記入の場合
  showSelectInterviewsheet(child) {
    let actionSheet = this.actionSheetController.create({
      title: "問診票を記入",
      buttons: [
        // スタッフ 選択画面
        {
          text: "スタッフが編集する",
          handler: () => {
            // スタッフが記入する画面
            this.navCtrl.push(InterviewSheetEditStaffPage, {
              child: child, // 子ども情報
              reserve: this.navParams.data.Reserve, // 予約情報
              isDetail: false,
            });
          },
        },
        // ご家族 選択画面
        {
          text: "ご家族に記入いただく",
          handler: () => {
            // 記入頂く
            const modal = this.modalController.create(
              InterviewSheetEditFamilyPage,
              {
                child: child, // 子ども情報
                reserve: this.navParams.data.Reserve, // 予約情報
                isDetail: false,
              },
              { enableBackdropDismiss: false }
            );
            modal.onDidDismiss(() => {
              // 戻ってきたら画面をリフレッシュする
              this.ionViewDidEnter();
            });

            modal.present();
          },
        },
        {
          text: "キャンセル",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }

  /**
   * スタッフ向け 問診票閲覧画面へ移動
   */
  goInterviewsheetStaffDetail(child) {
    this.navCtrl.push(InterviewSheetDetailStaffPage, {
      child: child,
      reserve: this.navParams.data.Reserve,
    });
  }


  /**
   * お迎え情報確認画面へ移動
   */
  goPickupEditPage(child) {
    //編集用データ準備（家族データ）
    var family = this.data.family.data.Family;
    var children = [];
    for (var index in this.data.children) {
      var d = this.data.children[index]["data"];
      children.push(d);
    }
    family["children"] = children;

    //編集用データ
    var data = {
      id: this.data.id,
      date: new Date(this.data.datetime.input.date),
      time: [
        new Date(this.data.datetime.input.time[0]),
        new Date(this.data.datetime.input.time[1]),
      ],
      family: family,
      type: this.data.type,
      bathRequest: this.data.bathRequest,
      status: this.data.status,
      pickup: this.data.pickup,
      isStaff: false,
    };

    let actionSheet = this.actionSheetController.create({
      title: "お迎え情報を記入",
      buttons: [
        // スタッフ 選択画面
        {
          text: "スタッフが編集する",
          handler: () => {
            data.isStaff = true;
            const modal = this.modalController.create(ReservePickupEditPage, data);
            modal.onDidDismiss(() => {
              // 戻ってきたら画面をリフレッシュする
              this.ionViewDidEnter();
            });
            modal.present();
          },
        },
        // ご家族 選択画面
        {
          text: "ご家族に記入いただく",
          handler: () => {
            data.isStaff = false;
            // モーダルで表示するようにしておく(端末をご家族にお渡しし、返却時にパスワード入力を求める)
            const modal = this.modalController.create(ReservePickupEditPage, data, {
              enableBackdropDismiss: false,
            });
            modal.onDidDismiss(() => {
              // 戻ってきたら画面をリフレッシュする
              this.ionViewDidEnter();
            });
            modal.present();
          },
        },
        {
          text: "キャンセル",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();

  }

  /**
   * お迎え情報確認画面へ移動
   */
  goPickupDetailPage(child) {
    this.navCtrl.push(ReservePickupDetailPage, {
      child: child,
      reserve: this.navParams.data.Reserve,
    });
  }

  /**
   * 体調不良・怪我連絡閲覧画面へ移動
   */
  goMessageSheet(child, family) {
    this.navCtrl.push(MessageSheetPage, { child: child, family: family });
  }

  /**
   * 予約日付
   */
  getReserveDate(d) {
    if (_.isEmpty(d)) return;
    d = d.datetime.date;
    return Utils.date.format(
      Utils.date.getDateFromHyphen(d),
      "yyyy年M月d日(EEEE)"
    );
  }

  /**
   * キャンセル日時を取得する
   */
  getCancelDate(cancelData): string {
    if (!cancelData) return "";
    return Utils.date.getBasicDatetime(new Date(cancelData.date));
  }

  /**
   * キャンセルした人を取得する
   */
  getCanceledPerson(cancelData) {
    if (!cancelData) return "";
    return cancelData.employee;
  }

  /**
   * 写真リクエスト返信可能状態にする
   */
  toEnablePhotoRequestReply() {
    this.confirm(
      this.alertController,
      "LINEから「写真リクエスト」を受信した状態にします。よろしいですか？",
      () => {
        this.reserveAction
          .toEnablePhotoRequestReply(this.data["id"])
          .subscribe((data) => {
            this.reserveAction.getListPhotoRequest().subscribe((data) => {
              //バッジ最新化
              this.badgeStore.setBadgePhotoRequest(data.data.length);
            });

            this.dataReload(this.data["id"]);
            this.toast(
              this.toastController,
              "写真リクエストへ返信可能となりました"
            ); //Toast
          });
      }
    );
  }

  /**
   * 写真返信画面へ
   */
  goPhotoRequestReply() {
    this.navCtrl.push(PhotoRequestSelectionPage, { Reserve: this.data });
  }

  /**
   * subscription破棄
   */
  ngOnDestroy() {
    this.captureData$.unsubscribe();
    this.captureDatas$.unsubscribe();
    this.onChangeChildDetail.unsubscribe();
    this.photoAction = null;
  }

  /**
   * 写真確認画面へ
   */
  goPhotoComplete() {
    this.navCtrl.push(PhotoRequestCompletePage, {
      PhotoRequest: this.data.photoRequest.data,
    });
  }

  /**
   * 同意書に同意していない場合のみ表示するbたん
   */
  goToSignatureAgreementPage() {
    let data = {
      agreementId: "",
      needResign: false,
      family: this.data.family.data.Family,
    };
    // this.navCtrl.push("SignatureAgreementPage", data);

    // モーダルで表示するようにしておく(端末をご家族にお渡しし、返却時にパスワード入力を求める)
    const modal = this.modalController.create(SignatureAgreementPage, data, {
      enableBackdropDismiss: false,
    });
    modal.onDidDismiss(() => {
      // 戻ってきたら画面をリフレッシュする
      this.ionViewDidEnter();
    });
    modal.present();
  }

  goNotePage(child) {

    let actionSheet = this.actionSheetController.create({
      title: "表示する内容を選択",
      buttons: [
        // スタッフ 選択画面
        {
          text: "今日の体調不良・怪我連絡",
          handler: () => {
            this.navCtrl.push(NotebookEditPage, {
              // 子供の情報
              child: child,
              familyId: this.data.family.data.Family.id,
              reserveId: this.navParams.data.Reserve.id,
              reserveDate: this.navParams.data.Reserve.datetime?.date,
              reserveTime: this.navParams.data.Reserve.datetime?.time,
            });
          },
        },
        // ご家族 選択画面
        {
          text: "これまでの体調不良・怪我連絡",
          handler: () => {
            this.navCtrl.push(NotebookListPage, { child: child });
          },
        },
        {
          text: "キャンセル",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/reserve/detail/reserve-detail.ts